const STORE_USER = 'hypha_user';
const STORE_ENTRIES = 'hypha_entries';

// --- User ---
export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(STORE_USER)) || {};
  } catch {
    return {};
  }
}

export function saveUser(u) {
  localStorage.setItem(STORE_USER, JSON.stringify(u));
}

// --- Entries (local) ---
export function getLocalEntries() {
  try {
    return JSON.parse(localStorage.getItem(STORE_ENTRIES)) || [];
  } catch {
    return [];
  }
}

export function saveEntries(entries) {
  localStorage.setItem(STORE_ENTRIES, JSON.stringify(entries));
}

export function addLocalEntry(text, date) {
  const entries = getLocalEntries();
  const entry = {
    id: `local_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`,
    text: text.trim(),
    date,
    timestamp: new Date().toISOString(),
  };
  entries.unshift(entry);
  saveEntries(entries);
  return entries;
}

export function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function hasTodayLocal() {
  return getLocalEntries().some(e => e.date === todayKey());
}

export function clearAll() {
  localStorage.removeItem(STORE_USER);
  localStorage.removeItem(STORE_ENTRIES);
}

// --- Questions ---
const QUESTIONS = [
  "What did you contribute today that no AI could replicate?",
  "What moment today required your full, irreplaceable presence?",
  "Where did you bring something human that no algorithm could?",
  "What did you do today that mattered because it was you?",
  "What connection did you create today that only a human could?",
  "What did you notice today that required being alive to see?",
  "Where did your humanity make the difference today?",
];

const ALT_PROMPTS = [
  { label: "Monday prompt", text: "Who did you help today — and how did it change you?" },
  { label: "Tuesday prompt", text: "What did you choose not to do today, and why did it matter?" },
  { label: "Wednesday prompt", text: "What did you notice that others missed?" },
  { label: "Thursday prompt", text: "What moment of genuine connection happened today?" },
  { label: "Friday prompt", text: "What did you create today that didn't exist before?" },
  { label: "Weekend reflection", text: "What are you carrying that only you can carry?" },
  { label: "Weekend reflection", text: "What would be lost if you hadn't shown up today?" },
];

export function getQuestion() {
  const week = Math.floor(Date.now() / (7 * 24 * 60 * 60 * 1000));
  return QUESTIONS[week % QUESTIONS.length];
}

export function getAltPrompt() {
  const day = new Date().getDay();
  return ALT_PROMPTS[day % ALT_PROMPTS.length];
}
